import { inspect } from 'util'

import Logger from '@openhouse-engineers/oh-js-utils/lib/utils/logger'
import { session } from '@openhouse-engineers/oh-js-utils/lib/utils/session'

import { isDevelopment } from 'helpers/miscellaneous'
import { getRoomName } from 'helpers/room'
import { getQueryParams } from 'helpers/urls'

session.set() // initialize ohm session id

const { REACT_APP_CUSTOM_NODE_ENV: environment } = process.env

const doNotInitiateLogger =
    isDevelopment ||
    (environment &&
        ['development', 'staging'].includes(environment.toLowerCase()))

const PRODUCT = 'oh-meets'

const room = getRoomName()
const queryParams = getQueryParams()

const sessionId = session.get()
const query = inspect(queryParams).replace(/:/g, ' ')
const sessionInfo = `[sId ${sessionId}] | [room ${room}] | [q ${query}]`

export const logger = new Logger(
    PRODUCT,
    sessionId,
    sessionInfo,
    environment,
    doNotInitiateLogger
)
